import { useDefaultPagination } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/Detail/LeftContent/TransactionsDetail/hooks/useInvoicesTransaction';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { FC, memo, useMemo } from 'react';
import { TransactionsDetailTable } from './TransactionsDetailTable';

export const LoadingTransactionsDetailTable: FC = memo(() => {
  const isOnline = useNetworkStatus();
  const pagination = useDefaultPagination();
  const tableProps = useMemo(
    () => ({ data: [], columns: [], loading: isOnline }),
    [isOnline]
  );
  return (
    <TransactionsDetailTable
      table={tableProps}
      pagination={pagination}
      isSearchEmpty={false}
    />
  );
});
LoadingTransactionsDetailTable.displayName = 'LoadingTransactionsDetailTable';
